import React from "react";

import { Box, TextField, Typography } from "@mui/material";

const Input = ({
  sx,
  error,
  label,
  value,
  variant,
  onChange,
  fieldLabel,
  placeholder,
  labelStyles,
  inputStyles,
  trigger,
  ...props
}) => {
  const variantStandard =
    variant === "standard"
      ? {
        fontFamily: 'Outfit',
        "& .MuiInput-underline:before": {
          borderBottomColor: "#F5F6F6", // Default color
        },
        "& .MuiInput-underline:hover:before": {
          borderBottomColor: "#F5F6F6", // Hover color
        },
      }
      : { fontFamily: 'Outfit', };
  const variantStandardLable =
    variant === "standard"
      ? { fontWeight: 400, fontSize: "12px", fontFamily: 'Outfit', color: "#A3A3A3" }
      : { fontFamily: 'Outfit', };

  return (
    <Box sx={sx}>
      {!fieldLabel && (
        <Typography
          color="#464646"
          fontSize="14px"
          fontWeight={500}
          mb={0.5}
          {...labelStyles}
        >
          {label}
        </Typography>
      )}
      <TextField
        value={value}
        variant={variant || "outlined"}
        label={fieldLabel && label}
        InputLabelProps={{
          sx: { fontSize: "17px", ...variantStandardLable, ...labelStyles },
        }}
        sx={{
          width: "100%",
          ...variantStandard,
          ...inputStyles,
        }}
        error={!!error}
        helperText={error}
        placeholder={placeholder}
        onChange={(e) => {
          onChange(e.target.value);
        }}
        {...props}
      />
    </Box>
  );
};

export default Input;
